import { State } from '../state';

export const ManageDeviceProfileSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedDeviceProfile: (state: State) => state.ManageDeviceProfiles.selectedDeviceProfile,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    manageDeviceProfiles: (state: State) => state.ManageDeviceProfiles,
};
